import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const NotFound = (props) => {
  const Navigation = useNavigate();
  return (
    <div>
      <Result
        status="404"
        title="404"
        subTitle="متاسفانه صفحه مورد نظر یافت نشد."
        extra={
          <Button onClick={() => Navigation("/")} type="primary">
            بازگشت به خانه
          </Button>
        }
      />
      ;
    </div>
  );
};

export default NotFound;
